import VideoPlayer from 'components/VideoPlayer'
import MediaCard from 'components/cards/new/common/MediaCard'
import Icon from 'components/Icon'
import classNames from 'classnames'
import { sectionGapSmall } from 'project/padding'

const keyBenefits = [
  'Real-time, secure messaging with no extra call costs',
  'A dedicated business number to separate work and personal chats',
  'Built-in tools for automation, quick replies, and marketing',
  'A familiar interface your customers already know and trust',
  'Work from anywhere, with a better work-life balance',
]

const otherBenefits = [
  {
    description: `Immediate response to customer questions & queries. <br /> Full relationship management, from basket to delivery and beyond.`,
    img: '/images/new/whatsapp/customer-support.png',
    title: 'Customer Support',
  },
  {
    description: `1-2-1 customer connection  <br class="d-none d-lg-block" /> throughout their lifetime via the <br class="d-none d-lg-block" /> WhatsApp Business app. <br /> In and outbound messaging for support, campaigns, offers and all <br class="d-none d-lg-block" /> types of engagement via the <br class="d-none d-lg-block" /> WhatsApp Business app.`,
    img: '/images/new/whatsapp/customer-communications.png',
    title: 'Customer Communications',
  },
  {
    description: `Set your profile, contact information <br class="d-none d-lg-block" /> and service details. <br /> Set up automated responses for the <br class="d-none d-lg-block" /> most commonly asked questions.`,
    img: '/images/new/whatsapp/automated-services.png',
    title: 'Automated Services',
  },
]

const KeyBenifitsCard = () => {
  return (
    <MediaCard
      image={{
        alt: 'Robot in WhatsApp paint',
        desktop: {
          dimensions: {
            height: 580,
            width: 647,
          },
          src: '/images/new/whatsapp/robot-in-wa-paint.png',
        },
        mobile: {
          dimensions: {
            height: 580,
            width: 647,
          },
          src: '/images/new/whatsapp/robot-in-wa-paint.png',
        },
      }}
      imageFitPreset='cover-left'
      imageContainerWidth='45%'
    >
      <div className='d-flex flex-column flex-1 px-4 pt-5 pt-lg-22 pb-lg-21 ps-lg-15 me-lg-n10 z-index-1'>
        <h2 className='lh-105 fw-semibold mb-6 fs-fluid-24-48 d-block pe-5'>
          Key benefits include:
        </h2>
        <ul className='list-unstyled'>
          {keyBenefits.map((benefit, index) => (
            <li key={index} className='d-flex mb-4 ps-0'>
              <Icon
                width={20}
                name='tick-circle'
                className='me-2 flex-shrink-0 mt-2'
              />
              <div
                className='fs-fluid-18-24 fw-semibold'
                dangerouslySetInnerHTML={{ __html: benefit }}
              />
            </li>
          ))}
        </ul>
      </div>
    </MediaCard>
  )
}

const OtherBenefitsSection = () => {
  return (
    <div className='row g-8'>
      {otherBenefits.map((benefit) => (
        <div className='col-12 col-lg-4' key={benefit.title}>
          <div className='card overflow-hidden h-auto'>
            <img src={benefit.img} alt={benefit.title} className='w-100' />
          </div>
          <div className='d-flex flex-column mt-8'>
            <h3 className='fs-fluid-18-28'>{benefit.title}</h3>
            <span
              className='fs-fluid-18-24 fw-semibold color-grey5'
              dangerouslySetInnerHTML={{ __html: benefit.description }}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

const WABenefits = () => {
  return (
    <>
      <div
        className={classNames(
          'd-flex flex-column align-items-center align-self-center',
          sectionGapSmall,
        )}
      >
        <div
          className='d-flex flex-column gap-3 text-center'
          style={{
            maxWidth: 1210,
          }}
        >
          <h2 className='fs-fluid-36-80 lh-105 lh-lg-114 fw-semibold'>
            Why use WhatsApp Business, <br className='d-none d-lg-block' /> the
            key business benefits.
          </h2>
          <div className='fs-fluid-18-24 fw-semibold color-grey5 mt-lg-6'>
            WhatsApp Business combines instant messaging, automation, and
            end-to-end encryption, giving modern businesses a fast, secure, and
            convenient way to connect with customers. All through your existing
            mobile phone.
          </div>
        </div>
        <div className='w-100'>
          <VideoPlayer
            src='/images/new/whatsapp/video.mp4'
            poster='/images/new/whatsapp/poster.png'
            showControls
          />
        </div>
      </div>
      <div
        className={classNames(
          sectionGapSmall,
          'container d-flex flex-column mt-4',
        )}
      >
        <KeyBenifitsCard />
        <OtherBenefitsSection />
        <span className='fs-fluid-18-20 fw-semibold text-lg-center'>
          The WhatsApp Business app is a free-to-download app available for both
          iOS and Android devices.
        </span>
      </div>
    </>
  )
}

export default WABenefits
